var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "orders-page" }, [
    _vm.order
      ? _c("div", { attrs: { tabindex: "0" } }, [
          _c("h2", { staticClass: "title", attrs: { "aria-live": "polite" } }, [
            _vm._v("Order " + _vm._s(_vm.order.id))
          ]),
          _c("p", [
            _c("b", [
              _vm._v("Purchased on " + _vm._s(_vm.getOrderDate(_vm.order)))
            ])
          ]),
          _c("div", { staticClass: "two-cols" }, [
            _c("div", [
              _c("div", { staticClass: "title" }, [_vm._v("Shipping Address")]),
              _c("div", [_vm._v(_vm._s(_vm.order.shipping_address.address1))]),
              _vm.order.shipping_address.address2
                ? _c("div", [
                    _vm._v(_vm._s(_vm.order.shipping_address.address2))
                  ])
                : _vm._e(),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.order.shipping_address.city) +
                    " " +
                    _vm._s(_vm.order.shipping_address.zip)
                )
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.order.shipping_address.country_code))
              ])
            ]),
            _c("div", [
              _c("div", { staticClass: "title" }, [_vm._v("Billing Address")]),
              _c("div", [_vm._v(_vm._s(_vm.order.billing_address.address1))]),
              _vm.order.billing_address.address2
                ? _c("div", [
                    _vm._v(_vm._s(_vm.order.billing_address.address2))
                  ])
                : _vm._e(),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.order.billing_address.city) +
                    " " +
                    _vm._s(_vm.order.billing_address.zip)
                )
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.order.billing_address.country_code))
              ])
            ])
          ]),
          _c("br"),
          _c("table", [
            _vm._m(0),
            _c(
              "tbody",
              _vm._l(_vm.order.line_items, function(item) {
                return _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.name))]),
                  _c("td", [_vm._v(_vm._s(item.sku))]),
                  _c("td", [
                    _vm._v("$" + _vm._s(item.price_set.shop_money.amount))
                  ]),
                  _c("td", [_vm._v(_vm._s(item.quantity))]),
                  _c("td", [_vm._v("$" + _vm._s(item.price))])
                ])
              }),
              0
            ),
            _c("tfoot", [
              _vm.order.total_discounts && _vm.order.total_discounts * 1 > 0
                ? _c("tr", [
                    _c("td", { attrs: { colspan: "4" } }, [_vm._v("Discount")]),
                    _c("td", [_vm._v("-$" + _vm._s(_vm.order.total_discounts))])
                  ])
                : _vm._e(),
              _c("tr", [
                _c("td", { attrs: { colspan: "4" } }, [_vm._v("Subtotal")]),
                _c("td", [
                  _vm._v("$" + _vm._s(_vm.order.current_subtotal_price))
                ])
              ]),
              _c("tr", [
                _c("td", { attrs: { colspan: "4" } }, [_vm._v("Shipping")]),
                _c("td", [
                  _vm._v(
                    "$" +
                      _vm._s(
                        _vm.order.total_shipping_price_set.shop_money.amount
                      )
                  )
                ])
              ]),
              _c("tr", [
                _c("td", { attrs: { colspan: "4" } }, [_vm._v("Total")]),
                _c("td", [_vm._v("$" + _vm._s(_vm.order.total_price))])
              ])
            ])
          ])
        ])
      : _vm.loading
      ? _c("div", { attrs: { tabindex: "0" } }, [_vm._v("loading...")])
      : _vm.orders.length === 0
      ? _c("div", { attrs: { "aria-live": "polite", tabindex: "0" } }, [
          _vm._v("No orders!")
        ])
      : _c("div", [
          _c("div", { staticClass: "title" }, [_vm._v("Order History")]),
          _c("table", [
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.orders, function(order, index) {
                return _c("tr", [
                  _c("td", [
                    _c("a", {
                      attrs: { href: "#" },
                      domProps: { textContent: _vm._s(order.id) },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openOrder(order)
                        }
                      }
                    })
                  ]),
                  _c("td", [_vm._v(_vm._s(_vm.getOrderDate(order)))]),
                  _c("td", [
                    _vm._v(_vm._s((order.financial_status || "").capitalize()))
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        (order.fulfillment_status || "Unfulfilled").capitalize()
                      )
                    )
                  ]),
                  _c("td", [_vm._v(_vm._s(order.current_total_price))])
                ])
              }),
              0
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Product")]),
        _c("th", [_vm._v("SKU")]),
        _c("th", [_vm._v("Price")]),
        _c("th", [_vm._v("Qty")]),
        _c("th", [_vm._v("Total")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Order")]),
        _c("th", [_vm._v("Date")]),
        _c("th", [_vm._v("Payment Status")]),
        _c("th", [_vm._v("Fulfillment Status")]),
        _c("th", [_vm._v("Total")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }